// Async bootstrap required for Module Federation: defers app startup until the
// shared react/react-dom singletons have been negotiated with the host.
import('./bootstrap');

